import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
import { createToObject } from 'pricing-pages-ui-components/utils/queryParamUtils';
import { BundlePage, CommerceHubPageV2, ContentHubPageV2, CustomerPlatformPageV2, DataHubPageV2, FreeToolsPageV2, HubSpotOnCreditsPage, MarketingHubPageV2, MarketingPlusPageV2, SalesHubPageV2, ServiceHubPageV2, SmartCrmPageV2 } from 'pricing-pages-ui/routes/loadablePages';
import { Redirect, Route, Switch } from 'quartz-routing/react-router';
import { useIsHubSpotOnCredits } from './hooks/useIsHubSpotOnCredits';
import { useIsStandaloneRoutesEnabled } from './hooks/useIsStandaloneRoutesEnabled';
import PublicAppLayout from './layouts/PublicAppLayout';
import PublicCommerceHubPage from './pages/commerce/PublicCommerceHubPage';
import PublicContentHubPage from './pages/content/PublicContentHubPage';
import PublicDataHubPage from './pages/data/PublicDataHubPage';
import PublicFreeToolsPage from './pages/free/PublicFreeToolsPage';
import PublicMarketingHubPage from './pages/marketing/PublicMarketingHubPage';
import PublicMarketingPlusPage from './pages/marketing-plus/PublicMarketingPlusPage';
import PublicPlatformPage from './pages/suite/PublicPlatformPage';
import PublicSalesHubPage from './pages/sales/PublicSalesHubPage';
import PublicServiceHubPage from './pages/service/PublicServiceHubPage';
import PublicSmartCrmPage from './pages/smart-crm/PublicSmartCrmPage';
import { getUseCasesByPage, useCasesQueryParamKey } from './utils/hsoc';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PublicRoutes() {
  const {
    isHubSpotOnCredits,
    loading: isHSoCPilotLoading
  } = useIsHubSpotOnCredits();
  const {
    isEnabled: isStandaloneRoutesEnabled,
    isStandaloneRoutesPhase2Enabled
  } = useIsStandaloneRoutesEnabled();
  if (isHSoCPilotLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }

  // HSOC is a full-width experience, no sidenav layout.
  if (isHubSpotOnCredits) {
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        exact: true,
        component: HubSpotOnCreditsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/:page",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => {
          const searchParams = new URLSearchParams(location.search);
          const useCases = getUseCasesByPage(page);
          for (const useCase of useCases) {
            searchParams.append(useCasesQueryParamKey, useCase);
          }
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              search: searchParams.toString(),
              pathname: '/'
            })
          });
        }
      })]
    });
  }
  return /*#__PURE__*/_jsx(PublicAppLayout, {
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/customer-platform",
        children: /*#__PURE__*/_jsx(Redirect, {
          to: createToObject('/suite')
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/cms",
        children: /*#__PURE__*/_jsx(Redirect, {
          to: createToObject('/content')
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/hubspot-credits",
        children: /*#__PURE__*/_jsx(Redirect, {
          to: createToObject('/')
        })
      }), /*#__PURE__*/_jsx(Route, {
        path: "/bundle",
        render: () => /*#__PURE__*/_jsx(BundlePage, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/marketing-plus",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicMarketingPlusPage, {}) : /*#__PURE__*/_jsx(MarketingPlusPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/crm",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicFreeToolsPage, {}) : /*#__PURE__*/_jsx(FreeToolsPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/suite",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicPlatformPage, {}) : /*#__PURE__*/_jsx(CustomerPlatformPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/marketing",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicMarketingHubPage, {}) : /*#__PURE__*/_jsx(MarketingHubPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/sales",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicSalesHubPage, {}) : /*#__PURE__*/_jsx(SalesHubPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/service",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicServiceHubPage, {}) : /*#__PURE__*/_jsx(ServiceHubPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/content",
        render: () => isStandaloneRoutesEnabled ? /*#__PURE__*/_jsx(PublicContentHubPage, {}) : /*#__PURE__*/_jsx(ContentHubPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/data",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicDataHubPage, {}) : /*#__PURE__*/_jsx(DataHubPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/commerce",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicCommerceHubPage, {}) : /*#__PURE__*/_jsx(CommerceHubPageV2, {})
      }), /*#__PURE__*/_jsx(Route, {
        path: "/smart-crm",
        render: () => isStandaloneRoutesPhase2Enabled ? /*#__PURE__*/_jsx(PublicSmartCrmPage, {}) : /*#__PURE__*/_jsx(SmartCrmPageV2, {})
      }), /*#__PURE__*/_jsx(Redirect, {
        from: "/",
        exact: true,
        to: createToObject('/marketing')
      })]
    })
  });
}